import { CourseId } from 'types/lesson';
import { JournalId } from 'types/journal';
import { VatRateType, VatReleaseReason } from 'types/settlementVatRates';

export enum PaymentConfiguration {
    EACH_LESSON = 'PER_UNIT',
    MONTHLY = 'FLAT_MONTHLY',
}

export enum SettlementConfiguration {
    PREPAID = 'PREPAID',
    POSTPAID = 'POSTPAID',
}

export type AdditionalLessonDTO = {
    configured: boolean;
    courseName: string;
    price: number | null;
    paymentType: PaymentConfiguration | null;
    settlementType: SettlementConfiguration | null;
    id: CourseId;
    free: boolean | null;
    vatRate: VatRateType | null;
    vatReleaseReasonType: VatReleaseReason | null;
    customVatReleaseReason: string | null;
};

export type EditAdditionalLessonDTO = Pick<
    AdditionalLessonDTO,
    'settlementType' | 'paymentType' | 'price'
> &
    Required<Pick<AdditionalLessonDTO, 'free'>> &
    Partial<
        Pick<AdditionalLessonDTO, 'vatRate' | 'vatReleaseReasonType' | 'customVatReleaseReason'>
    >;

export type AdditionalLessonJournalDTO = {
    journalId: JournalId;
    journalName: string;
};
